import { HTTP_STATUS } from 'affiny-core/helpers/AsyncStatusHandler';
import { retry, UntilFunction } from 'wretch-middlewares';

const DELAY = 1000;
const MAX_ATTEMPTS = 3;

export const shallRetry: UntilFunction = response => {
  if (!response) return true;

  switch (true) {
    case response.ok: // the response is ok, no need to retry
    case response.status === HTTP_STATUS.TOO_MANY_REDIRECTS: // to many redirect, not useful to add more
    case response.status >= HTTP_STATUS.BAD_REQUEST &&
      response.status <= HTTP_STATUS.INTERNAL_SERVER_ERROR:
    case response.status === HTTP_STATUS.NOT_IMPLEMENTED:
    case response.status === HTTP_STATUS.HTTP_VERSION_NOT_SUPPORTED:
    case response.status > HTTP_STATUS.HTTP_VERSION_NOT_SUPPORTED: // do not retry 4xx and 5xx
      return false;

    case response.status === HTTP_STATUS.BAD_GATEWAY_OR_GATEWAY_TIMEOUT:
    case response.status === HTTP_STATUS.SERVICE_UNAVAILABLE:
    case response.status === HTTP_STATUS.GATEWAY_TIMEOUT:
    default:
      return true;
  }
};

export const not = (fn: UntilFunction) => (response: Response) => !fn(response);

export const retryMiddleware = (customRetryCondition = not(shallRetry)) =>
  retry({
    delayTimer: DELAY,
    // 1s, 3s, 9s
    delayRamp: (delay, nbOfAttempts) => delay * Math.pow(nbOfAttempts + 1, 2),
    maxAttempts: MAX_ATTEMPTS,
    until: customRetryCondition,
    /*
    // we could update the payment retry with this function only if onRetry accept async function
    // https://github.com/elbywan/wretch-middlewares/issues/3
    onRetry: ({ response, url, options }) => {
      const accessToken = await getNewToken();
      const newOptions = getNewOpts(options, accessToken);
      return { url, options: newOptions };
    },*/
  });
